import axios from 'axios'

export const getRulesReq = (accountID) => axios.get(`/rules/${accountID}`)

export const getRulesAvailableReq = (accountID) => axios.get(`/rules/available/${accountID}`)

// export const updateRulesReq = (accountID, data) => axios.post(`/rules/${accountID}`, data)

export const updateRulesReq = (accountID, ruleGUID, data) => axios.put(`/rules/${accountID}/${ruleGUID}/update`, data)
